module.exports = __webpack_public_path__ + "4e89b1a99cf2c2df1a44f593fc5eb810.png";